import { Injectable } from '@angular/core';
import { Response, ResponseContentType, RequestOptions, URLSearchParams } from '@angular/http';

import { AuthHttp } from 'app/infrastructure/common/index';
import { AppSettings } from 'app/infrastructure/settings/index';

@Injectable()
export class OnlineOrderReportService {
    constructor(private http: AuthHttp) { }

    exportOrderConfirmationReport(searchParams: any): any {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            let value = undefined;

            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }

            params.set(key, value);
        }

        let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderReport/ExportOrderConfirmationReport", options)
            .map(
            (response: Response) => {
                var contentType = 'application/pdf';
                return new Blob([response.blob()], { type: 'application/pdf' });
            }
            );
    }

    exportInventoryBalanceReport(searchParams: any): any {
        let params: URLSearchParams = new URLSearchParams();
        // params.set('SessionId', searchParams.SessionId);
        // params.set('ReportName', searchParams.ReportName);
        // params.set('OwnerCode', searchParams.OwnerCode);
        // params.set('FromWarehouseCode', searchParams.FromWarehouseCode);
        // params.set('ToWarehouseCode', searchParams.ToWarehouseCode);
        // params.set('FromProductCode', searchParams.FromProductCode);
        // params.set('ToProductCode', searchParams.ToProductCode);
        // params.set('FromLotNo', searchParams.FromLotNo);
        // params.set('ToLotNo', searchParams.ToLotNo);
        // params.set('AsAtDate', searchParams.AsAtDate && searchParams.AsAtDate.toUTCString());
        // params.set('FromExpiryDate', searchParams.FromExpiryDate && searchParams.FromExpiryDate.toUTCString());
        // params.set('ToExpiryDate', searchParams.ToExpiryDate && searchParams.ToExpiryDate.toUTCString());
        // params.set('InvStatus', searchParams.InvStatus);
        // params.set('FromAsnNo', searchParams.FromAsnNo);
        // params.set('ToAsnNo', searchParams.ToAsnNo);
        // params.set('FromPoNo', searchParams.FromPoNo);
        // params.set('ToPoNo', searchParams.ToPoNo);
        // params.set('FromGrnNo', searchParams.FromGrnNo);
        // params.set('ToGrnNo', searchParams.ToGrnNo);
        // params.set('IsPalletVisible', searchParams.IsPalletVisible);
        // params.set('IsContainerVisible', searchParams.IsContainerVisible);
        // params.set('DateFormat', searchParams.DateFormat);
        // params.set('ReportFormat', searchParams.ReportFormat);
        // alert(searchParams["FromExpiryDate"]);
        for (let key in searchParams) {
            let value = undefined;

            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }

            params.set(key, value);
        }
        // alert(searchParams["FromExpiryDate"]);

        // alert(JSON.stringify(searchParams));


        let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderReport/ExportInventoryBalanceReport", options)
          .map(
          (response: Response) => {

              let contentType = response.headers.get('Content-Type');
              return new Blob([response.blob()], { type: contentType });
          }
        );
    }

    exportInventoryMovementDetailReport(searchParams: any): any {
      let params: URLSearchParams = new URLSearchParams();
      // params.set('SessionId', searchParams.SessionId);
      // params.set('ReportName', searchParams.ReportName);
      // params.set('OwnerCode', searchParams.OwnerCode);
      // params.set('FromWarehouseCode', searchParams.FromWarehouseCode);
      // params.set('ToWarehouseCode', searchParams.ToWarehouseCode);
      // params.set('FromProductCode', searchParams.FromProductCode);
      // params.set('ToProductCode', searchParams.ToProductCode);
      // params.set('FromLotNo', searchParams.FromLotNo);
      // params.set('ToLotNo', searchParams.ToLotNo);
      // params.set('AsAtDate', searchParams.AsAtDate && searchParams.AsAtDate.toUTCString());
      // params.set('FromExpiryDate', searchParams.FromExpiryDate && searchParams.FromExpiryDate.toUTCString());
      // params.set('ToExpiryDate', searchParams.ToExpiryDate && searchParams.ToExpiryDate.toUTCString());
      // params.set('InvStatus', searchParams.InvStatus);
      // params.set('FromAsnNo', searchParams.FromAsnNo);
      // params.set('ToAsnNo', searchParams.ToAsnNo);
      // params.set('FromPoNo', searchParams.FromPoNo);
      // params.set('ToPoNo', searchParams.ToPoNo);
      // params.set('FromGrnNo', searchParams.FromGrnNo);
      // params.set('ToGrnNo', searchParams.ToGrnNo);
      // params.set('IsPalletVisible', searchParams.IsPalletVisible);
      // params.set('IsContainerVisible', searchParams.IsContainerVisible);
      // params.set('DateFormat', searchParams.DateFormat);
      // params.set('ReportFormat', searchParams.ReportFormat);
      // alert(searchParams["FromExpiryDate"]);
      for (let key in searchParams) {
          let value = undefined;

          if (searchParams[key] && searchParams[key] instanceof Date) {
              value = searchParams[key].toUTCString();
          } else {
              value = searchParams[key];
          }

          params.set(key, value);
      }
      // alert(searchParams["FromExpiryDate"]);

      // alert(JSON.stringify(searchParams));


      let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob });
      return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderReport/ExportInventoryMovementDetailReport", options)
        .map(
        (response: Response) => {

            let contentType = response.headers.get('Content-Type');
            return new Blob([response.blob()], { type: contentType });
        }
      );
  }

    exportInventoryBalanceWithQtyAvailableReport(searchParams: any): any {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            params.set(key, searchParams[key]);
        }

        let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob });
        // let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.ArrayBuffer });
        // let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderReport/ExportInventoryBalanceWithQtyAvailableReport", options)
            .map(
            (response: Response) => {
                // alert(JSON.stringify(response));
                //  window.open(response, '_blank', '');
                // var contentType = 'application/pdf';
                // return new Blob([response.blob()], { type: 'application/pdf' });

                let contentType = response.headers.get('Content-Type');
                return new Blob([response.blob()], { type: contentType });
            }
            );
        //   .map(
        // (response: Response) => {
        //     alert(JSON.stringify(response));
        //     return response.json();
        // }
        // );
    }

    // private handleError(error: any) {
    //     // In a real world app, we might use a remote logging infrastructure
    //     // We'd also dig deeper into the error to get a better message

    //     alert(JSON.stringify(error));
    //     let errMsg = (error.message) ? error.message :
    //         error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    //     alert(errMsg); // log to console instead
    //     return Observable.throw(errMsg);
    // }

    exportInventoryBalanceExcel(searchParams: any): any {
        let params: URLSearchParams = new URLSearchParams();
        // params.set('SessionId', searchParams.SessionId);
        // params.set('ReportName', searchParams.ReportName);
        // params.set('OwnerCode', searchParams.OwnerCode);
        // params.set('FromWarehouseCode', searchParams.FromWarehouseCode);
        // params.set('ToWarehouseCode', searchParams.ToWarehouseCode);
        // params.set('FromProductCode', searchParams.FromProductCode);
        // params.set('ToProductCode', searchParams.ToProductCode);
        // params.set('FromLotNo', searchParams.FromLotNo);
        // params.set('ToLotNo', searchParams.ToLotNo);
        // params.set('AsAtDate', searchParams.AsAtDate && searchParams.AsAtDate.toUTCString());
        // params.set('FromExpiryDate', searchParams.FromExpiryDate && searchParams.FromExpiryDate.toUTCString());
        // params.set('ToExpiryDate', searchParams.ToExpiryDate && searchParams.ToExpiryDate.toUTCString());
        // params.set('InvStatus', searchParams.InvStatus);
        // params.set('FromAsnNo', searchParams.FromAsnNo);
        // params.set('ToAsnNo', searchParams.ToAsnNo);
        // params.set('FromPoNo', searchParams.FromPoNo);
        // params.set('ToPoNo', searchParams.ToPoNo);
        // params.set('FromGrnNo', searchParams.FromGrnNo);
        // params.set('ToGrnNo', searchParams.ToGrnNo);
        // params.set('IsPalletVisible', searchParams.IsPalletVisible);
        // params.set('IsContainerVisible', searchParams.IsContainerVisible);
        // params.set('DateFormat', searchParams.DateFormat);
        // params.set('ReportFormat', searchParams.ReportFormat);
        // alert(searchParams["FromExpiryDate"]);
        for (let key in searchParams) {
            let value = undefined;

            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }

            params.set(key, value);
        }
        // alert(searchParams["FromExpiryDate"]);

        // alert(JSON.stringify(searchParams));


        let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderReport/ExportInventoryBalanceReportExcel", options)
          .map(
          (response: Response) => {

              let contentType = response.headers.get('Content-Type');
              return new Blob([response.blob()], { type: contentType });
          }
        );
    }

    exportInventoryMovementDetailExcel(searchParams: any): any {
        let params: URLSearchParams = new URLSearchParams();
        // params.set('SessionId', searchParams.SessionId);
        // params.set('ReportName', searchParams.ReportName);
        // params.set('OwnerCode', searchParams.OwnerCode);
        // params.set('FromWarehouseCode', searchParams.FromWarehouseCode);
        // params.set('ToWarehouseCode', searchParams.ToWarehouseCode);
        // params.set('FromProductCode', searchParams.FromProductCode);
        // params.set('ToProductCode', searchParams.ToProductCode);
        // params.set('FromLotNo', searchParams.FromLotNo);
        // params.set('ToLotNo', searchParams.ToLotNo);
        // params.set('AsAtDate', searchParams.AsAtDate && searchParams.AsAtDate.toUTCString());
        // params.set('FromExpiryDate', searchParams.FromExpiryDate && searchParams.FromExpiryDate.toUTCString());
        // params.set('ToExpiryDate', searchParams.ToExpiryDate && searchParams.ToExpiryDate.toUTCString());
        // params.set('InvStatus', searchParams.InvStatus);
        // params.set('FromAsnNo', searchParams.FromAsnNo);
        // params.set('ToAsnNo', searchParams.ToAsnNo);
        // params.set('FromPoNo', searchParams.FromPoNo);
        // params.set('ToPoNo', searchParams.ToPoNo);
        // params.set('FromGrnNo', searchParams.FromGrnNo);
        // params.set('ToGrnNo', searchParams.ToGrnNo);
        // params.set('IsPalletVisible', searchParams.IsPalletVisible);
        // params.set('IsContainerVisible', searchParams.IsContainerVisible);
        // params.set('DateFormat', searchParams.DateFormat);
        // params.set('ReportFormat', searchParams.ReportFormat);
        // alert(searchParams["FromExpiryDate"]);
        for (let key in searchParams) {
            let value = undefined;
  
            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }
  
            params.set(key, value);
        }
        // alert(searchParams["FromExpiryDate"]);
  
        // alert(JSON.stringify(searchParams));
  
  
        let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderReport/ExportInventoryMovementDetailReportExcel", options)
          .map(
          (response: Response) => {
  
              let contentType = response.headers.get('Content-Type');
              return new Blob([response.blob()], { type: contentType });
          }
        );
    }

    GetInventoryMovementDetailReportByPage(searchParams: any): any {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in searchParams) {
            let value = undefined;
  
            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }
  
            params.set(key, value);
        }
  
        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderReport/GetInventoryMovementDetailReportByPage", options)
          .map((response: Response) => response.json());
    }

    exportInventoryBalanceLWINExcel(searchParams: any): any {
        let params: URLSearchParams = new URLSearchParams();
        
        for (let key in searchParams) {
            let value = undefined;

            if (searchParams[key] && searchParams[key] instanceof Date) {
                value = searchParams[key].toUTCString();
            } else {
                value = searchParams[key];
            }

            params.set(key, value);
        }
        // alert(searchParams["FromExpiryDate"]);

        // alert(JSON.stringify(searchParams));


        let options: RequestOptions = new RequestOptions({ search: params, responseType: ResponseContentType.Blob });
        return this.http.get(AppSettings.apiEndpoint + "OnlineShipmentOrderReport/ExportInventoryBalanceLWINReportExcel", options)
          .map(
          (response: Response) => {

              let contentType = response.headers.get('Content-Type');
              return new Blob([response.blob()], { type: contentType });
          }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/transaction/op/outbound/order/online-order-report.service.ts